export default {
  ANY: 'any',
  CHILD: 'child',
  SELF: 'self'
};
